exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tab[data-v-192d9b3b] {\n    border-bottom-width: 2px;\n    font-weight: bold;\n    font-size: 14px;\n}\n.tab.active[data-v-192d9b3b],\n.tab[data-v-192d9b3b]:hover {\n    color: #fff;\n    border-bottom: solid 2px #00aef1 !important;\n    background: #00aef1;\n}\n", ""]);

// exports
